<div class="body">
  <span class="header">
    <span class="header-project-number">{{ project }}</span>
    <span *ngIf="projectData" 
          class="material-icons header-info-icon" 
          [ngClass]="{'hover-trigger': true}"
          (mouseenter)="showProjectCard = true; projectCardPosition = { x: $event.clientX + 10, y: $event.clientY + 10 };"
          (mouseleave)="showProjectCard = false;">info_outline</span>
    <br />
    <br />
  </span>

  <span class="context-menu" *ngIf="showProjectCard" [ngStyle]="{'top.px': projectCardPosition.y, 'left.px': projectCardPosition.x}">
    <project-card *ngIf="projectData" [projectData]="projectData"></project-card>
  </span>

  <master-schedule-calendar
    [project]="project"
    [filterSettings]="filterSettings"
    [firstDateLeadInDays]="5"
    [projectNumberClickEnabled]="projectNumberClickEnabled">
  </master-schedule-calendar>
</div>